import Link from "next/link";
import PropTypes from "prop-types";
import "../../../styles/scss/blog-tags.module.scss";

export type TopicTagLink = { slug: string; name: string };

const BlogCategoryTags = ({
  categoryName,
  categoryDescription,
  topicTags = [],
}: {
  categoryName: string;
  categoryDescription?: string | null;
  topicTags?: TopicTagLink[];
}) => {
  return (
    <>
      <div className={"blog-category-tags"}>
        <div className={"container"}>
          <div className="d-flex">
            <div className={"left-block"}>
              <h2>
                Observability <span className="text-gradient">{categoryName} </span> Hub
              </h2>
              <p>{categoryDescription}</p>
            </div>
            <div className="right-block">
              <div className="popular-tags">Popular Topics</div>
              <div className="tags">
                {topicTags.map(({ slug, name }) => (
                  <Link
                    key={slug}
                    href={`/topics/${slug}/`}
                    className="read-more"
                  >
                    {name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

BlogCategoryTags.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categoryDescription: PropTypes.string,
  topicTags: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
};
export default BlogCategoryTags;